@import '../../../../app-brand/entities/entity-layer.module.less';

.title {
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-900);
  font-weight: 500;
}

.amount {
  font-size: 20px;
  line-height: 24px;
  color: var(--grey-900);
  display: flex;
  align-items: center;
}

.auto-fund-icon {
  color: var(--default--icon--fill-color--11);
  height: 16px;
  margin-left: 2px;
}

.subtext {
  font-size: 14px;
  line-height: 15px;
  color: var(--grey-600);
}

.link {
  font-size: 12px;
  text-align: right;
}

.add-funds {
  color: var(--black);
  margin: 30px 0 4px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}

.banner {
  display: flex;
  align-items: center;
  min-height: 30px;
  line-height: 18px;
  padding: 2px 12px;
  gap: 8px;
  font-size: 14px;
  background-color: var(--banner-message--info-background-color--2);

  > svg {
    height: 16px;
    color: var(--primary--icon--fill-color--3);
  }
}
